"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const font = '#171717';
const inverseFont = '#fff'; // shared colours, review usages below and separate them out if necessary before changing.

const red = '#ce283c';
const amber = '#f88f00';
const success = '#1c880b';
const mediumBlue = '#006cb5';
const darkGrey = '#a4a5a8';
const mediumGrey = '#ebebeb';
const lightGrey = '#f1f1f1';
const paleGrey = '#fafafa';
const colours = {
  primary: '#ff055e',
  font,
  pink: '#ff055e',
  green: '#72d74d',
  amber,
  red,
  white: '#fff',
  success: '#1c880b',
  blue: mediumBlue,
  paleGrey,
  lightGrey,
  lightBlue: '#0093f6',
  mediumGrey,
  darkGrey,
  black: '#000',
  highlightBlue: '#00BFFF19',
  pinkActive: '#ce0049',
  activeState: '#72d74d',
  inactiveState: darkGrey,
  multiSelect: mediumBlue,
  activeFilterBar: paleGrey,
  activeFilter: mediumGrey,
  buttonBackground: '#f3f3f3',
  buttonBorder: '#d9d9d9',
  buttonBackgroundActive: lightGrey,
  buttonBorderActive: '',
  border: '#e7e7e7',
  backgroundDisabled: mediumGrey,
  textDisabled: darkGrey,
  cardTop: paleGrey,
  cardBottom: '#fff',
  listDarkBackground: lightGrey,
  tabsBottomBorder: '#d8d8d8',
  infoTitleBackground: mediumGrey,
  textareaActive: mediumBlue,
  wizardCircleButton: '#d8d8d8',
  wizardTitleSeparator: lightGrey,
  wizardCardBackground: paleGrey,
  tableRowSelected: mediumBlue,
  tableRowInvalid: 'rgba(248, 143, 0, 0.05)',
  transparentShadow: 'rgba(0, 0, 0, 0.1)',
  inputGrayTextColor: '#6f7071',
  inputBorderColor: '#ced4da',
  inputFocus: mediumBlue,
  inputBorder: '#e7e7e7',
  inputError: '#f44336',
  // theme.palette.error.main
  separator: mediumGrey,
  tooltipBg: '#323232',
  paperContainer: '#f9f9f9',
  cards: {
    critical: {
      background: red,
      text: inverseFont
    },
    success: {
      background: success,
      text: inverseFont
    },
    other: {
      background: amber,
      text: font
    },
    neutral: {
      background: mediumBlue,
      text: inverseFont
    }
  },
  toaster: {
    infoBorder: '#1d71b8',
    infoBackground: 'rgba(29, 113, 184, 0.05)',
    successBorder: '#7ed321',
    successBackground: 'rgba(126, 211, 33, 0.05)',
    warningBorder: '#f5a623',
    warningBackground: 'rgba(245, 166, 35, 0.05)',
    errorBorder: '#d0021b',
    errorBackground: 'rgba(208, 2, 27, 0.05)'
  }
};
var _default = colours;
exports.default = _default;